import React, { useState, useEffect } from "react";
import "./Budget.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc } from "firebase/firestore";

const DDOPending = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (sessionStorage.getItem("login") !== "true") {
            navigate("/");
        }
    }, []);

    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [actionPlan, setActionPlan] = useState([]);
    const [demands, setDemands] = useState({});
    const [budgetData, setBudgetData] = useState({
        ageneral: 0, ascsp: 0, acfld: 0, anicra: 0, aother: 0,
        ugeneral: 0, uscsp: 0, ucfld: 0, unicra: 0, uother: 0,
        bgeneral: 0, bscsp: 0, bcfld: 0, bnicra: 0, bother: 0,
    });
    const name = localStorage.getItem("empname");
    const empId = localStorage.getItem("empid");

    window.emplist = [];
    useEffect(() => {
        if (!month) return;
        if (empId == "32") {
            window.emplist = ["1", "2", "3", "4", "5", "6", "37", "42", "47", "52", "57", "62", "63", "72", "73", "82"];
        }
        if (empId == "33") {
            window.emplist = ["7", "8", "9", "10", "11", "12", "38", "43", "48", "53", "58", "64", "65", "74", "75", "83"];
        }
        if (empId == "34") {
            window.emplist = ["13", "14", "15", "16", "17", "18", "39", "44", "49", "54", "59", "66", "67", "76", "77", "84"];
        }
        if (empId == "35") {
            window.emplist = ["19", "20", "21", "22", "23", "24", "40", "45", "50", "55", "60", "68", "69", "78", "79", "85"];
        }
        if (empId == "36") {
            window.emplist = ["25", "26", "27", "28", "29", "30", "41", "46", "51", "56", "61", "70", "71", "80", "81", "86"];
        }
        console.log(window.emplist);

        const fetchActionPlan = async () => {
            try {
                const q = query(
                    collection(db, "actionplan"),
                    where("empid", "in", window.emplist),
                    where("month", "==", String(month + " " + year)),
                );

                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    setActionPlan([]);
                    setDemands({});
                    return;
                }

                const actions = [];
                const demandsObj = {};

                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    // Apply filter: only include documents where accremarks is not an empty string
                    if (data.accremarks && data.accremarks !== "") {
                        const id = doc.id;

                        const demandDate = data.demanddate?.toDate
                            ? data.demanddate.toDate().toLocaleDateString('en-GB')
                            : "N/A";
                        const ddodate = data.ddodate && data.ddodate.toDate
                            ? data.ddodate.toDate().toLocaleDateString('en-GB')
                            : "N/A";

                        actions.push({
                            id: id,
                            supportdoc: data.supportdoc,
                            code: data.programCode || "",
                            text: data.program || "",
                            budgetApproved: data.budgetapproved || 0,
                            currentstatus: data.currentstatus || "Not Placed",
                            demanddate: demandDate,
                            td: data.td || "",
                            budgetDemand: data.budgetdemand || "",
                            budgethead: data.budgethead || "",
                            ddodate: ddodate,
                            totamount: data.totamount || "",
                            ddoremarks: data.ddoremarks || "",
                            accremarks: data.accremarks || "",
                            empname: data.empname || "",
                            empdesig: data.empdesig || ""
                        });

                        demandsObj[id] = {
                            td: data.td || "",                            
                            budgetdemand: data.budgetdemand || "",
                            totamount: data.totamount || "",
                            placed: data.currentstatus !== "Not Placed",
                            currentstatus: data.currentstatus || "Not Placed",
                            demanddate: demandDate,
                            ddodate: ddodate,
                            budgethead: data.budgethead || "",
                            ddoremarks: data.ddoremarks || "",
                            accremarks: data.accremarks || ""
                        };
                    }
                });

                setActionPlan(actions);
                setDemands(demandsObj);
            } catch (error) {
                console.error("Error fetching action plans:", error);
            }
        };

        fetchActionPlan();
    }, [month, year]);

    const handleDemandPlace = async (id) => {
        const budgetText = demands[id]?.budgetdemand.trim();
        const totAmount = parseFloat(demands[id]?.totamount);

        if (!budgetText || isNaN(totAmount)) {
            alert("Please enter both budget demand and total amount before placing.");
            return;
        }

        try {
            const actionRef = doc(db, "actionplan", id);
            await updateDoc(actionRef, {
                budgetdemand: budgetText,
                totamount: totAmount,
                currentstatus: `Forwarded to SS & Head on ${new Date().toLocaleDateString('en-GB')}`,
                ddodate: new Date(),
            });

            const updatedDemands = { ...demands };
            updatedDemands[id].placed = true;
            updatedDemands[id].currentstatus = `Forwarded to SS & Head on ${new Date().toLocaleDateString('en-GB')}`;
            updatedDemands[id].demanddate = new Date();
            setDemands(updatedDemands);
        } catch (error) {
            console.error("Error updating budget demand and totals:", error);
        }
    };

    const handleApproveForward = async (id) => {
        const ddoremarks = demands[id]?.ddoremarks.trim();

        if (!ddoremarks) {
            alert("Please add DDO remarks before approving and forwarding.");
            return;
        }

        try {
            const actionRef = doc(db, "actionplan", id);
            await updateDoc(actionRef, {
                ddoremarks: ddoremarks,
                currentstatus: `Forwarded to SS & Head on ${new Date().toLocaleDateString('en-GB')}`,
                ddodate: new Date(),
            });

            const updatedDemands = { ...demands };
            updatedDemands[id].currentstatus = `Forwarded to SS & Head on ${new Date().toLocaleDateString('en-GB')}`;
            setDemands(updatedDemands);
        } catch (error) {
            console.error("Error forwarding demand to SS & Head:", error);
        }
    };
    const handleBack = (e) => {
        e.preventDefault();
        navigate(-1)
    }
    return (
        <div className="container">
            <h1 className="welcome">Seeking Approval of DDO</h1>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label className="label">Select Month and Year:</label>
                    <select className="dropdown" id="dd1" value={month} onChange={(e) => setMonth(e.target.value)}>
                        <option value="">Month</option>
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
                            <option key={m} value={m}>{m}</option>
                        ))}
                    </select>
                </div>
                <select className="dropdown" id="dd2" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: '150px', height: '40px', marginTop: '33px' }}>
                    <option value="">Year</option>
                    {["2025", "2026", "2027", "2028"].map((m) => (
                        <option key={m} value={m}>{m}</option>
                    ))}
                </select>
            </div>

            {actionPlan.length > 0 && (
                <div className="action-section">
                    <table className="action-table">
                        <thead>
                            <tr>
                                <th>Applicant</th>
                                <th>Budget Head</th>
                                <th>Program Code & <br />Title / Subject</th>
                                <th>Supporting Document</th>
                                <th>Details of Notesheet</th>
                                <th>Accountant Remarks</th>
                                <th>DDO Remarks / Current Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actionPlan.map((action) => (
                                <tr key={action.id}>
                                    <td>{action.empname} <br /> {action.empdesig}</td>
                                    <td>{action.budgethead}</td>
                                    <td>{action.code} <br /> {action.text}</td>
                                    <td>
                                        {action.supportdoc ?
                                            <a href={action.supportdoc} target="_blank"><button>View Document</button></a>
                                            : ""
                                        }
                                    </td>
                                    <td>
                                        <textarea
                                            rows="4"
                                            className="textarea-box"
                                            value={demands[action.id]?.td || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].td = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                        />
                                        <textarea
                                            rows="4"
                                            className="textarea-box"
                                            value={demands[action.id]?.budgetdemand || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].budgetdemand = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                        />
                                        <input
                                            type="number"
                                            placeholder="Enter Total Amount"
                                            value={demands[action.id]?.totamount || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].totamount = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                            className="textarea-box"
                                        />
                                        {!demands[action.id]?.placed && demands[action.id]?.currentstatus === "Not Placed" && (
                                            <button className="place-btn full-width" onClick={() => handleDemandPlace(action.id)}>
                                                Place Demand
                                            </button>
                                        )}
                                        {demands[action.id]?.placed && (
                                            <h4 style={{ color: "green" }}>Demand Placed on {demands[action.id]?.demanddate}</h4>
                                        )}
                                    </td>
                                    <td>
                                        <textarea
                                            rows="4"
                                            className="textarea-box"
                                            value={demands[action.id]?.accremarks || ""}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        {demands[action.id]?.placed && (
                                            <>
                                                <textarea
                                                    rows="4"
                                                    placeholder="Enter DDO Remarks"
                                                    className="textarea-box"
                                                    value={demands[action.id]?.ddoremarks || ""}
                                                    onChange={(e) => {
                                                        const updatedDemands = { ...demands };
                                                        updatedDemands[action.id].ddoremarks = e.target.value;
                                                        setDemands(updatedDemands);
                                                    }}
                                                />
                                                <button disabled={demands[action.id]?.currentstatus.includes("Forwarded to DDO") == false} style={{ backgroundColor: 'lightblue', cursor: 'pointer', height: '26px', border: 'none' }} className="approve-btn full-width" onClick={() => handleApproveForward(action.id)}>
                                                    Approve & Forward
                                                </button>
                                                <h4 style={{ color: "green" }}>{demands[action.id]?.currentstatus}</h4>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

        </div>
    );
};

export default DDOPending;